import type { FC, ReactNode } from "react";
import { ArrowUpRight } from "lucide-react";

import { Button } from "@/components/ui/button";

interface ProfileCardProps {
  title: string;
  updateLabel: string;
  onUpdateClick: () => void;
  onDeleteClick?: () => void;
  deleteLabel?: string;
  children: ReactNode;
}

const ProfileCard: FC<ProfileCardProps> = ({
  title,
  updateLabel,
  onUpdateClick,
  onDeleteClick,
  deleteLabel,
  children,
}) => {
  return (
    <div className="flex flex-col rounded-lg border border-[#E2E8F0] bg-white w-full sm:w-[calc(50%-0.75rem)] lg:w-[calc(30%-1rem)] min-w-[280px]">
      {/* Header */}
      <div className="py-[10px] px-5 gap-3 font-semibold text-[#101828]">
        {title}
      </div>
      {/* Content */}
      {children}
      {/* Footer */}
      <div
        className={`flex w-full ${onDeleteClick && deleteLabel ? "justify-between" : "justify-end"} border-t py-4 gap-4`}
      >
        {onDeleteClick && deleteLabel && (
          <Button
            variant={"text"}
            className="flex px-6 gap-[6px] text-sm text-error-700 font-semibold"
            size={"none"}
            onClick={onDeleteClick}
          >
            {deleteLabel}
            <ArrowUpRight height={20} width={20} />
          </Button>
        )}
        <Button
          variant={"text"}
          className="flex px-6 gap-[6px] text-sm text-brand-700 font-semibold"
          size={"none"}
          onClick={onUpdateClick}
        >
          {updateLabel}
          <ArrowUpRight height={20} width={20} />
        </Button>
      </div>
    </div>
  );
};

export default ProfileCard;
